import { Query } from 'graphql/generated/graphqlTypes';
import {
  mockVisitor1,
  mockVisitor10KeySharing,
  mockVisitor11WithCard,
  mockVisitor12WithBlockedCard,
  mockVisitor15WithoutGroup,
  mockVisitor16Disconnected,
  mockVisitor17ExpiringIn24h,
  mockVisitor18ExpiringThisWeek,
  mockVisitor19DisconnectedWithCard,
  mockVisitor2,
  mockVisitor20Inactive,
  mockVisitor3WithGroups,
  mockVisitor4,
  mockVisitor5WithGroups,
  mockVisitor6,
  mockVisitor7WithGroups,
  mockVisitor8ExpiringTomorrow,
  mockVisitor9Expired,
  mockVisitorCoContractor1,
  mockVisitorCoContractor2,
  mockVisitorInstaller2
} from 'mocks/graphqlMocks/visitorFixtures';

export function mockedGetVisitorDetailsData(getVisitorById: Query['getVisitorById']): Pick<Query, 'getVisitorById'> {
  return {
    getVisitorById
  };
}

export const mockedGetVisitorDetailsDataForQueryVisitor1 = mockedGetVisitorDetailsData(mockVisitor1);

export const mockedGetVisitorDetailsDataForQueryVisitor2 = mockedGetVisitorDetailsData(mockVisitor2);

export const mockedGetVisitorDetailsDataForQueryVisitor3 = mockedGetVisitorDetailsData(mockVisitor3WithGroups);

export const mockedGetVisitorDetailsDataForQueryVisitor5 = mockedGetVisitorDetailsData(mockVisitor5WithGroups);

export const mockedGetVisitorDetailsDataForQueryVisitor4 = mockedGetVisitorDetailsData(mockVisitor4);

export const mockedGetVisitorDetailsDataForQueryVisitor6 = mockedGetVisitorDetailsData(mockVisitor6);

export const mockedGetVisitorDetailsDataForQueryVisitor7 = mockedGetVisitorDetailsData(mockVisitor7WithGroups);

export const mockedGetVisitorDetailsDataForQueryVisitor8 = mockedGetVisitorDetailsData(mockVisitor8ExpiringTomorrow);

export const mockedGetVisitorDetailsDataForQueryVisitor9 = mockedGetVisitorDetailsData(mockVisitor9Expired);

export const mockedGetVisitorDetailsDataForQueryVisitor10 = mockedGetVisitorDetailsData(mockVisitor10KeySharing);

export const mockedGetVisitorDetailsDataForQueryVisitor11 = mockedGetVisitorDetailsData(mockVisitor11WithCard);

export const mockedGetVisitorDetailsDataForQueryVisitor12 = mockedGetVisitorDetailsData(mockVisitor12WithBlockedCard);

export const mockedGetVisitorDetailsDataForQueryVisitor13 = mockedGetVisitorDetailsData(mockVisitorCoContractor1);

export const mockedGetVisitorDetailsDataForQueryVisitor14 = mockedGetVisitorDetailsData(mockVisitorCoContractor2);

export const mockedGetVisitorDetailsDataForQueryVisitorInstaller2 = mockedGetVisitorDetailsData(mockVisitorInstaller2);

export const mockedGetVisitorDetailsDataForQueryVisitor15 = mockedGetVisitorDetailsData(mockVisitor15WithoutGroup);

export const mockedGetVisitorDetailsDataForQueryVisitor16 = mockedGetVisitorDetailsData(mockVisitor16Disconnected);

export const mockedGetVisitorDetailsDataForQueryVisitor17 = mockedGetVisitorDetailsData(mockVisitor17ExpiringIn24h);

export const mockedGetVisitorDetailsDataForQueryVisitor18 = mockedGetVisitorDetailsData(mockVisitor18ExpiringThisWeek);

export const mockedGetVisitorDetailsDataForQueryVisitor19 = mockedGetVisitorDetailsData(
  mockVisitor19DisconnectedWithCard
);

export const mockedGetVisitorDetailsDataForQueryVisitor20 = mockedGetVisitorDetailsData(mockVisitor20Inactive);
